module.exports = __webpack_public_path__ + "static/media/3.caef5d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/soligorsk/3.jpg
// module id = 542
// module chunks = 0